import PageTitle from "../../../Components/Pages/PageTitle.jsx";
import PageVideo from "../../../Components/Pages/PageVideo.jsx";
import PageText from "../../../Components/Pages/PageText.jsx";
import "../../../style.css";

export default function BiologieCellulaire() {

	return (
		<>
			<PageTitle>Cell<br /> BIOLOGY</PageTitle>

			<PageText animatedBlock={false}>
				<p>
					<span><span className="first">Marie is now going to tell us all about what happens in the <span className="bold">cell biology laboratory</span>.</span></span>
					<br />
					<span><span className="second">Would you like to find out more about the techniques used on <span className="bold">skin samples</span> ?</span></span>
				</p>
			</PageText>

			<PageText>
				<div
					style={{
						height: "30vh",
						width: "100%",
						borderRadius: "5px",
						backgroundImage: `url(${"/images/pages/BiologieCellulaire/biologieCellulaire1.png"})`,
						backgroundSize: "cover",
						backgroundPosition: "center",
						zIndex: 1
					}}
				/>
			</PageText>

			<PageVideo videoName={"itwDorr1"} style={{ paddingBottom: '100px' }}>
				Marie Dorr<br />PROJECT MANAGER – IN VITRO ASSESSMENT
			</PageVideo>

			<PageVideo videoName={"demoExplant"} backgroundImage={"linear-gradient(#eee8e2, #fff)"} style={{ paddingTop: '40px' }}>
				PREPARING SKIN SAMPLES
			</PageVideo>
		</>
	)
}
